import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import Document from '../requestDocuments/document';
import { DOCUMENT_STATUS, RFA_STATUS } from '../../../utils/constant';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const slash = '/';
export const RequestSpecificDocumentsListView = props => {
  const isSuccess = !props.loading && !props.error && props.uploadedDocCount === props.documents.length;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex-container space-between mt-5",
      children: /*#__PURE__*/_jsxs("h2", {
        className: "no-wrap",
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "request.page.specificDocuments"
        }), /*#__PURE__*/_jsx("span", {
          className: "separator"
        }), /*#__PURE__*/_jsx("span", {
          className: isSuccess ? 'success' : 'warning',
          children: /*#__PURE__*/_jsxs("strong", {
            children: [props.uploadedDocCount, slash, props.documents.length]
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "card",
      children: props.error ? /*#__PURE__*/_jsx("span", {
        "data-id": "error-message",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "error.generic"
        })
      }) : props.loading ? /*#__PURE__*/_jsx("div", {
        className: "loading-overlay"
      }) : /*#__PURE__*/_jsx("div", {
        className: "flex-container column",
        children: props.documents.map((document, index) => /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Document, {
            document: document,
            requestId: props.requestId,
            onDocumentUpload: props.onDocumentUpload,
            rfaStatus: props.rfaStatus
            // When either subcontractor or inviting organisation, show upload button
            ,
            isUploadVisible: props.isSubcontractor || props.isInvitingOrganisation
            // When the RFA is completely signed, the uploaded is authorized on MISSING document
            ,
            isUploadEnabled: props.rfaStatus === RFA_STATUS.VALIDATED && document.state === DOCUMENT_STATUS.MISSING ? true : props.rfaStatus === RFA_STATUS.EDITABLE
          })
        }, index))
      })
    })]
  });
};
RequestSpecificDocumentsListView.defaultProps = {
  loading: true,
  error: false,
  isSubcontractor: false,
  isInvitingOrganisation: false
};
RequestSpecificDocumentsListView.propTypes = {
  requestId: PropTypes.number.isRequired,
  documents: PropTypes.array.isRequired,
  uploadedDocCount: PropTypes.number.isRequired,
  rfaStatus: PropTypes.string,
  isSubcontractor: PropTypes.bool,
  isInvitingOrganisation: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onDocumentUpload: PropTypes.func.isRequired
};
export default RequestSpecificDocumentsListView;